import { useIntl } from 'react-intl';

export const DEFAULT_NOTIFICATION_TITLE_MESSAGES = {
  general: 'Notification',
  auth: 'Authentication',
  payments: 'Payments',
  settings: 'Settings',
  graves: 'Graves',
  gravesHub: 'Graves Hub',
  memoryWall: 'Memory Wall',
  requests: 'Requests',
  notifications: 'Notifications',
  groups: 'Groups',
  sparks: 'Sparks',
  store: 'Store',
  purchase: 'Purchase',
  userProfile: 'My Light',
  messaging: 'Messages',
  connectRequests: 'Connection Requests',
  designSystem: 'Design System',
  subscription: 'Subscription',
  comments: 'Comments',
  header: 'Header',
  familyTree: 'Family Tree',
};

export const getNotificationTitle = (intl, context = 'general') => {
  const defaultMessage =
    DEFAULT_NOTIFICATION_TITLE_MESSAGES[context] ||
    DEFAULT_NOTIFICATION_TITLE_MESSAGES.general;

  return intl.formatMessage({
    id: `notifications.${context}.title`,
    defaultMessage,
  });
};

export const useNotificationTitle = (context = 'general') => {
  const intl = useIntl();
  return getNotificationTitle(intl, context);
};

export const NOTIFICATION_TITLE_CONTEXTS = Object.freeze({
  GENERAL: 'general',
  AUTH: 'auth',
  PAYMENTS: 'payments',
  SETTINGS: 'settings',
  GRAVES: 'graves',
  GRAVES_HUB: 'gravesHub',
  MEMORY_WALL: 'memoryWall',
  REQUESTS: 'requests',
  NOTIFICATIONS: 'notifications',
  GROUPS: 'groups',
  SPARKS: 'sparks',
  STORE: 'store',
  PURCHASE: 'purchase',
  USER_PROFILE: 'userProfile',
  MESSAGING: 'messaging',
  CONNECT_REQUESTS: 'connectRequests',
  DESIGN_SYSTEM: 'designSystem',
  SUBSCRIPTION: 'subscription',
  COMMENTS: 'comments',
  HEADER: 'header',
  FAMILY_TREE: 'familyTree',
});

export default useNotificationTitle;
